module.exports = __webpack_public_path__ + "img/tg_02 (1).297ed326.jpg";